
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_1mt7g_9",
  "scrolling-background": "awsui_scrolling-background_hyvsj_1mt7g_12",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_1mt7g_19",
  "drawers-container": "awsui_drawers-container_hyvsj_1mt7g_24",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_1mt7g_35",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_1mt7g_59",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_1mt7g_64",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_1mt7g_102",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_1mt7g_115",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_1mt7g_120",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_1mt7g_134",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_1mt7g_120",
  "drawer": "awsui_drawer_hyvsj_1mt7g_24",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_1mt7g_168",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_1mt7g_177",
  "drawer-content": "awsui_drawer-content_hyvsj_1mt7g_168",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_1mt7g_186",
  "drawer-slider": "awsui_drawer-slider_hyvsj_1mt7g_189",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_1mt7g_197",
  "content": "awsui_content_hyvsj_1mt7g_219",
  "layout": "awsui_layout_hyvsj_1mt7g_236",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_1mt7g_308",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_1mt7g_323",
  "content-type-table": "awsui_content-type-table_hyvsj_1mt7g_337",
  "content-type-cards": "awsui_content-type-cards_hyvsj_1mt7g_337",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_1mt7g_343",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_1mt7g_346",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_1mt7g_360",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_1mt7g_363",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_1mt7g_373",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_1mt7g_376",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_1mt7g_376",
  "has-header": "awsui_has-header_hyvsj_1mt7g_376",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_1mt7g_391",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_1mt7g_391",
  "has-left-toggles-gutter": "awsui_has-left-toggles-gutter_hyvsj_1mt7g_411",
  "has-right-toggles-gutter": "awsui_has-right-toggles-gutter_hyvsj_1mt7g_414",
  "has-split-panel": "awsui_has-split-panel_hyvsj_1mt7g_434",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_1mt7g_434",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_1mt7g_442",
  "unfocusable": "awsui_unfocusable_hyvsj_1mt7g_447",
  "container": "awsui_container_hyvsj_1mt7g_453",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_1mt7g_479",
  "is-tools-open": "awsui_is-tools-open_hyvsj_1mt7g_482",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_1mt7g_482",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_1mt7g_482",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_1mt7g_482",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_1mt7g_487",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_1mt7g_504",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_1mt7g_508",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_1mt7g_512",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_1mt7g_516",
  "navigation-container": "awsui_navigation-container_hyvsj_1mt7g_521",
  "show-navigation": "awsui_show-navigation_hyvsj_1mt7g_559",
  "animating": "awsui_animating_hyvsj_1mt7g_582",
  "showButtons": "awsui_showButtons_hyvsj_1mt7g_1",
  "navigation": "awsui_navigation_hyvsj_1mt7g_521",
  "openNavigation": "awsui_openNavigation_hyvsj_1mt7g_1",
  "animated-content": "awsui_animated-content_hyvsj_1mt7g_646",
  "content-container": "awsui_content-container_hyvsj_1mt7g_649",
  "hide-navigation": "awsui_hide-navigation_hyvsj_1mt7g_658",
  "notifications": "awsui_notifications_hyvsj_1mt7g_664",
  "has-notification-content": "awsui_has-notification-content_hyvsj_1mt7g_669",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_1mt7g_673",
  "high-contrast": "awsui_high-contrast_hyvsj_1mt7g_678",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_1mt7g_692",
  "position-bottom": "awsui_position-bottom_hyvsj_1mt7g_739",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_1mt7g_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_1mt7g_768",
  "position-side": "awsui_position-side_hyvsj_1mt7g_781",
  "tools-container": "awsui_tools-container_hyvsj_1mt7g_799",
  "tools": "awsui_tools_hyvsj_1mt7g_799",
  "openTools": "awsui_openTools_hyvsj_1mt7g_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_1mt7g_891",
  "hide-tools": "awsui_hide-tools_hyvsj_1mt7g_901",
  "show-tools": "awsui_show-tools_hyvsj_1mt7g_913",
  "has-tools-form": "awsui_has-tools-form_hyvsj_1mt7g_891",
  "trigger-button-styles": "awsui_trigger-button-styles_hyvsj_1mt7g_989",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_1mt7g_1005",
  "trigger": "awsui_trigger_hyvsj_1mt7g_989",
  "selected": "awsui_selected_hyvsj_1mt7g_1057",
  "badge": "awsui_badge_hyvsj_1mt7g_1077",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_1mt7g_1081",
  "trigger-wrapper-tooltip-visible": "awsui_trigger-wrapper-tooltip-visible_hyvsj_1mt7g_1092",
  "dot": "awsui_dot_hyvsj_1mt7g_1096",
  "trigger-tooltip": "awsui_trigger-tooltip_hyvsj_1mt7g_1109"
};
  